$(document).ready(function() {
  // Announcebar
  $('.announcement_bar_slider').slick({
    autoplay:true,
    arrows:false,
    dots:false,
    infinite: true,
    slidesToShow:1,
    autoplaySpeed: 0,
    speed: 15000,
    variableWidth: true,
    pauseOnHover: false,
    cssEase: 'linear',
    slidesToScroll:3
  });
  // Hero Banner
  $('.hero_banner_slider').slick({
    autoplay:true,
    autoplaySpeed:1500,
    arrows:false,
    dots:true,
    infinite: true,
    slidesToShow:1,
    adaptiveHeight: true,
    slidesToScroll:1
  });
  // Collection Slider
  $('.collection_slider').slick({
    arrows:true, 
    dots:true,
    slidesToShow:4,
    autoplay:true,
    infinite: true,
    slidesToScroll:1,
    autoplaySpeed:1000,
    prevArrow: $('#collection_slider_prev'),
    nextArrow: $('#collection_slider_next'),
    appendDots: '#collection_slider_dot',
    responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '60px',
          }
        },
        {
          breakpoint: 370,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '30px',
          }
        }
      ]
  });
  
let observer = new MutationObserver(checkForElement);
      const config = { childList: true, subtree: true };
      observer.observe(document.body, config);
      function checkForElement() {
        let element = document.querySelector('.related-products ul');
        if (element) {
          observer.disconnect(); // Stop the MutationObserver
          $('.related_collection_slider').slick({
        arrows:true, 
        dots:true,
        slidesToShow:4,
        autoplay:true,
        infinite: true,
        slidesToScroll:1,
        autoplaySpeed:1000,
        prevArrow: $('#related_collection_slider_prev'),
        nextArrow: $('#related_collection_slider_next'),
        appendDots: '#related_collection_slider_dot',
        responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '60px',
              }
            },
            {
              breakpoint: 370,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '30px',
              }
            }
          ]
      });
        }
      }
  
  $('.collection_tab_content_slider').each(function(){
    $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: false,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: true,
        dots: true,
        nextArrow: $(this).parents(".collection_tab_content_main").find('.collection_tab_next'),
        prevArrow: $(this).parents(".collection_tab_content_main").find('.collection_tab_prev'),
       appendDots: $(this).parents(".collection_tab_content_main").find('.collection_tab_dot'),
       responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '60px',
          }
        },
        {
          breakpoint: 370,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '30px',
          }
        }
      ]
    });
  });
  $('.collection_tab_content_slider').slick('setPosition');
  
    $('ul.collection_tab_nav li').click(function(){
        var tab_id = $(this).attr('data-tab');
  
        $('ul.collection_tab_nav li').removeClass('active');
        $('.collection_tab_content_main').removeClass("active");
  
        $(this).addClass('active');
        $("#"+tab_id).addClass("active");
     
        $('.collection_tab_content_slider').slick('setPosition');
    })
  
  // Video Slider
$('.video_slider').slick({
        arrows: false,
        centerMode: true,
        centerPadding: '0',
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '120px',
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '40px',
            }
          },
          {
            breakpoint: 370,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px',
            }
          }
        ]
    });

    // Function to play the video in the active slide and pause others
    function playActiveVideo() {
        $('.video_slider .slick-slide').each(function(){
            var video = $(this).find('video').get(0);
            if (video) { // Check if a video element is found
                if ($(this).hasClass('slick-center')) {
                    video.play();
                } else {
                    video.pause();
                    video.currentTime = 0; // Optional: reset the video to the beginning
                }
            }
        });
    }

    // Event listener for after the slide change
    $('.video_slider').on('afterChange', function(event, slick, currentSlide){
        playActiveVideo();
    });

    // Initial call to play the video in the active slide after initialization
    $('.video_slider').on('init', function(event, slick){
        playActiveVideo();
    });

    // Manually trigger 'init' event to ensure videos are correctly handled on load
    $('.video_slider').slick('setPosition');
  
// review
  $('.review_slider').slick({
    arrows:true,
    dots:true,
    slidesToShow:3,
    infinite: true,
    slidesToScroll:1,
    prevArrow: $('.review_slider_prev'),
    nextArrow: $('.review_slider_next'),
    appendDots: '.review_slider_dot',
    responsive: [ 
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '80px',
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '25px',
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  });

  $(".collection_header_button_2").click(function() {
    $(".collection_header_button").removeClass("active");
    $(this).addClass("active");
    $("#product-grid").removeClass("product-grid-4");
    $("#product-grid").addClass("product-grid-2");    
  });
  $(".collection_header_button_4").click(function() {
    $(".collection_header_button").removeClass("active");
    $("#product-grid").removeClass("product-grid-2");
    $(this).addClass("active");    
    $("#product-grid").addClass("product-grid-4");    
  });
  
if($(window).width() < 768){
  $('.footer_menu ul').hide();
      $('.footer_menu h2').unbind().click(function(){
      $('.footer_menu h2').not($(this)).removeClass('active');
      $('.footer_menu ul').not($(this).siblings('.footer_menu ul')).slideUp();
      $(this).siblings('.footer_menu ul').slideToggle();
      $(this).toggleClass('active');
    });
  }
$(window).resize(function(){
  if($(window).width() < 768){
    $('.footer_menu ul').hide();
    $('.footer_menu h2').unbind().click(function(){
    $('.footer_menu h2').not($(this)).removeClass('active');
    $('.footer_menu ul').not($(this).siblings('.footer_menu ul')).slideUp();
    $(this).siblings('.footer_menu ul').slideToggle();
    $(this).toggleClass('active');
  });
}
else{
  $('.footer_menu ul').show();
}
  
});

$('ul.product_tab_nav li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.product_tab_nav li').removeClass('current');
    $('.product_tab_content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
});

  $(".main_product_accordion_header").click(function() {
    $(this).toggleClass("active");     
    $(this).parent(".main_product_accordion").find(".main_product_accordion_content").slideToggle();     
  })

  $(".product-popup-close").click(function() {
    $(this).parents(".product-popup").removeClass("active");     
  })

    $(".main-product-share").click(function() {
        $(this).parents(".product-form__input").find(".share-button__button").trigger("click");
    });
  
  var win = $(window),isInProgress = false;
  win.on('scroll',function() {
    if(!isInProgress) {
      if ((win.scrollTop()+win.height()) >= $('.jj--service-section').offset().top) {
        var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
        if(currentPage >= totalPages) return;
        currentPage = currentPage+1;
        var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
        $('[data-current-page]').val(currentPage);
        isInProgress = true;
        $('.loaderWrap').addClass('show');
        setTimeout(function() {
          $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML){
              $('.product-grid').append($(responseHTML).find('.product-grid').html());
            },
            complete: function(){
              isInProgress = false;
              $('.loaderWrap').removeClass('show');
            }
          });
         }, 500);
      }
    }
  });

  $('.faq-acc-container .faq-acc:nth-child(1) .faq-acc-head').addClass('active');
  $('.faq-acc-container .faq-acc:nth-child(1) .faq-acc-content').slideDown();
  $('.faq-acc-head').on('click', function() {
      if($(this).hasClass('active')) {
          $(this).siblings('.faq-acc-content').slideUp();
          $(this).removeClass('active');
      }
      else {
          $('.faq-acc-content').slideUp();
          $('.faq-acc-head').removeClass('active');
          $(this).siblings('.faq-acc-content').slideToggle();
          $(this).toggleClass('active');
      }
  });     
  
});